import React, { useCallback } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { fetchEquipmentTypesLookup } from '../../../actions/lookupActions';
import BinaryTargetTypeSelect from './BinaryTargetTypeSelect';
import {
    isTargetSelected,
    optionsTransform,
    targetChangeHandler,
    RULE_TARGET_TO_TYPE
} from './targetMappings';

const EquipmentTargetSelect = ({
    disabled,
    errors,
    fetchEquipmentTypesLookup,
    onChange,
    onPatch,
    touched,
    values,
    ...props
}) => {
    const dispatch = useDispatch();
    const equipmentTypes = useSelector(
        ({ equipmentTypes }) => equipmentTypes
    );

    function handleRenderable() {
        dispatch(fetchEquipmentTypesLookup());
    }

    const handleChange = useCallback(
        targetChangeHandler(onPatch, {
            targetEquipmentTypes: []
        })
    );

    const options = [
        {
            error:     equipmentTypes.error,
            isLoading: equipmentTypes.loading,
            items:     optionsTransform(equipmentTypes.data),
            name:      'Equipment Types',
            itemProps: {
                type: RULE_TARGET_TO_TYPE.targetEquipmentTypes
            }
        }
    ];

    return (
        <BinaryTargetTypeSelect
            controlValue="Equipment"
            disabled={disabled}
            errors={errors}
            grouped
            isItemSelected={isTargetSelected}
            kickerText="Add any Equipment Types that this Rule will be applied to"
            label="Equipment"
            name="targetEquipmentTypes"
            onRenderable={handleRenderable}
            onTargetChange={onChange}
            onTargetTypeChange={handleChange}
            options={options}
            placeholder="Add Equipment"
            ruleId={values.id}
            ruleTemplateId={values.ruleTemplateId}
            target={values.target}
            targetType={equipmentTypes}
            touched={touched}
            value={values.targetEquipmentTypes}
            {...props}
        />
    );
};

EquipmentTargetSelect.defaultProps = {
    disabled: false,
    errors:   {},
    fetchEquipmentTypesLookup,
    onChange: () => {},
    onPatch:  () => {},
    touched:  {},
    values:   {
        targetEquipmentTypes: []
    }
};

EquipmentTargetSelect.propTypes = {
    disabled: bool,
    errors:   shape({
        target: string
    }),
    fetchEquipmentTypesLookup: func,
    onChange:                  func,
    onPatch:                   func,
    touched:                   shape({
        target: bool
    }),
    values: shape({
        id:                   string,
        target:               string,
        targetEquipmentTypes: array.isRequired
    })
};

export default EquipmentTargetSelect;
